import '../../../ProductCard/ProductCard.scss';
import './Wrapper.scss';

import React, { useContext } from 'react';
import {
	useIsMediumAndAbove,
	useIsSmallOnly,
} from '../../../../hooks/mediaQueries';

import { Context } from '../../store/store';
import CustomCatLargeListViewContent from '../ListViewContent/CustomCatLargeListViewContent@default';
import LargeListViewContent from '../ListViewContent/LargeListViewContent@default';
import SmallListViewContent from '../ListViewContent/SmallListViewContent@default';
import TradingRangeFlag from '../../../ProductCard/TradingRangeFlag/TradingRangeFlag';
import loadable from '@loadable/component';
import { useSelector } from 'react-redux';

const RecommendationCarousel = loadable(() =>
	import('../../../ProductCard/RecommendationCarousel/RecommendationCarousel')
);

const CardContent = ({ index, product, tradingRangeInfo, isFeatured }) => {
	const {
		ListerAlternativeProductsEnabled,
		CustomCategoriesEnabled,
	} = useSelector((state) => state.experimentSwitches);

	const [state] = useContext(Context);
	const { loaded } = state;

	const isSmallOnly = useIsSmallOnly();
	const isMediumAndAbove = useIsMediumAndAbove();

	return (
		<>
			<div className="flex">

				{isSmallOnly && (
					<SmallListViewContent {...{ product, tradingRangeInfo }} />
				)}

				{isMediumAndAbove && (
					<>
						{loaded && tradingRangeInfo && (
							<TradingRangeFlag
								{...tradingRangeInfo}
								isFeatured={isFeatured}
								enableHover
							/>
						)}

						{!CustomCategoriesEnabled && (
							<LargeListViewContent {...{ product }} />
						)}
						{CustomCategoriesEnabled && (
							<CustomCatLargeListViewContent {...{ product }} />
						)}
					</>
				)}
			</div>

			{ListerAlternativeProductsEnabled && product.State === 'OutOfStock' && (
				<RecommendationCarousel NowPrice={product.PricePodViewModel.NowPrice} />
			)}
		</>
	);
};

export default CardContent;
